Vue.component('home', {
    props: ['user', 'launchview'],
    data: function(){
        return {
            launchViewProperty: "",
            launchViewPushed: false
        }
    },
    mounted() {
        this.launchViewProperty = this.launchview;
        if(this.launchViewProperty != "" && this.launchViewPushed == false){
            this.$router.push({ name: this.launchViewProperty});
            this.launchViewProperty = "";
            this.launchViewPushed = true;
        }
    },
    methods: {
    },
});
